module.exports = __webpack_public_path__ + "img/pdf-icon.6cee79c9.png";